import React, {useEffect} from 'react';
import LoginLoader from './LoginLoader';
import styled from 'styled-components';
import {centeredFlex, fontSize, headerHeight, tabletWidth} from '../../mixins';
import Terms from '../auth/Terms';
import {useDispatch, useSelector} from 'react-redux';
import {selectToken, selectUsername} from '../auth/authSlice';
import Header from '../../UI/Header/Header';
import {fetchData, selectStatus} from './loginSlice';
import {selectPseudoFlow} from '../onboarding/onboardingSlice';

const StyledContainer = styled.div`
  ${centeredFlex};
  height: 100%;
  padding-top: calc(${headerHeight} + 5vh);
  padding-left: 6px;
  padding-right: 6px;
`

const StyledUpperBlock = styled.div`
  height: 70%;
  max-height: 500px;
  min-height: 400px;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  
  p {
    ${fontSize(16)};
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.41px;
    color: #323232;
    mix-blend-mode: normal;
    font-weight: 500;
  }
`

const StyledTitle = styled.h1`
  font-weight: 700;
  ${fontSize(26)};
  line-height: 33px;
  text-align: center;
  color: #323232;
  mix-blend-mode: normal;
  
  @media screen and (min-width: ${tabletWidth}) {
      ${fontSize(34)};
  }
`


const LoginScreen = ({history}) => {
    const name = useSelector(selectUsername);
    const token = useSelector(selectToken);
    const status = useSelector(selectStatus);
    const dispatch = useDispatch();
    const isPseudoFlow = useSelector(selectPseudoFlow);

    useEffect(() => {
        if (token) {
            dispatch(fetchData(token));
        }

    }, [token]);


    useEffect(() => {
        if (!!status) {
            history.push('/dashboard')
        }
    }, [status])



    return (
        <>
            <Header/>
            <StyledContainer>
                <StyledUpperBlock>
                    <StyledTitle>{isPseudoFlow ? `Welcome to Geozilla!` : `Welcome, ${name}!`}</StyledTitle>
                    <LoginLoader/>
                    <p>Signing you in...</p>
                </StyledUpperBlock>
                <Terms/>
            </StyledContainer>
        </>
    )
};


export default LoginScreen;